import Alert from "../../../../../global/components/Alert/Alert.vue";
import FormstepDetail from "../../../../../global/components/FormstepDetail/FormstepDetail.vue";
import PuxTranslate from "../../../../../global/components/PuxTranslate/PuxTranslate.vue";

import HttpMixin from "../../../../../global/mixins/HttpMixin";
import PermissionMixin from "../../../../../global/mixins/PermissionMixin";

import {
  toFormElementFromParameter
} from "../../../../../global/functions/mappingForParameterToFormElement";
import {
  find,
  get,
  isNil,
  map,
  pick,
  size,
} from "lodash-es";

// @vue/component
export default {
  name: "Konfiguration",
  components: {
    Alert,
    FormstepDetail,
    PuxTranslate,
  },
  mixins: [
    HttpMixin,
    PermissionMixin,
  ],
  props: {
    statusfunktion: {
      type: Object,
      required: true,
      info: "Hauptinformation",
    },
    updateStatusfunktion: {
      type: Function,
      required: true,
      info: "Statusfunktion aktualisieren",
    },
  },
  computed: {
    canEdit() {
      return this.hasConfig && this.checkPermissionsSync({ perm: "statusfunktion.update" });
    },

    options() {
      const OPTIONS = {
        label: "_TXT_STATUSFUNKTION_DETAILS_KONFIGURATION_PANEL_FORMSTEP_NAME_",
        info: "_HTML_STATUSFUNKTION_DETAILS_KONFIGURATION_PANEL_FORMSTEP_INFO_",
        list: toFormElementFromParameter({
          obj: this.statusfunktion.config_in,
          showLabel: true,
        }).list,
        saveCallback: this.save,
      };
      OPTIONS.required = !isNil(find(OPTIONS.list, el => get(el, "required") || get(el, "options.required")));
      return OPTIONS;
    },

    hasConfig() {
      return size(this.options.list) > 0;
    },
  },
  methods: {
    save({ model }) {
      const DATA = {
        wts_parameterin: pick(model, map(this.options.list, option => option.id))
      };
      return this.patchHttp({
        url: `statusfunktionen/${ this.statusfunktion.pk }/`,
        data: DATA,
      }).then(
        response => {
          this.updateStatusfunktion({ statusfunktion: response });
          this.addNotification({
            text: "_MSG_STATUSFUNKTION_DETAILS_KONFIGURATION_UPDATE_SUCCESS_{{bez}}_",
            extra: {
              bez: this.statusfunktion.wts_bez,
            },
          });
        },
        errors => {
          const CONF_ERROR = {
            data: get(errors, "data.wts_parameterin", get(errors, "data", errors))
          };
          return Promise.reject(CONF_ERROR);
        }
      );
    },
  },
};
